import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import { crearCita, actualizarCita, eliminarCita } from "../../services/citaService";
import { TRATAMIENTOS } from "../../services/tratamientos";
import '../../styles/ModalNuevaCita.css';
import ModalNuevoPaciente from "../calendario/ModalNuevoPaciente";

export default function ModalNuevaCita({ profesional, cita, onClose, onCitaCreada }) {
  const [pacientes, setPacientes] = useState([]);
  const [tratamientos, setTratamientos] = useState([]);
  const [paciente, setPaciente] = useState(null);
  const [tratamiento, setTratamiento] = useState(null);
  const [fecha, setFecha] = useState("");
  const [hora, setHora] = useState("");
  const [duracion, setDuracion] = useState(30);
  const [mostrarModalPaciente, setMostrarModalPaciente] = useState(false);
  const [cargandoPacientes, setCargandoPacientes] = useState(true);
  const [profesionalSeleccionado, setProfesionalSeleccionado] = useState(!profesional || profesional === "ALL" ? "MARIA" : profesional);

  const guardar = async () => {
    if (!paciente || !tratamiento) return;
    const payload = {
      profesional: profesionalSeleccionado,
      nExpediente: paciente.value,
      paciente: paciente.label.split(" - ").slice(1).join(" - "),
      tratamiento: tratamiento.label,
      color: tratamiento.color,
      fechaInicio: `${fecha}T${hora}:00`,
      duracionMin: duracion
    };

    if (cita?.id) {
    // EDITAR
      await actualizarCita(cita.id, payload);
    } else {
      console.log(paciente);
      console.log(payload.paciente);
      await crearCita(payload);
    }

    onCitaCreada(); // callback al calendario
    onClose();
  };

  useEffect(() => {
    const cargarPacientes = async () => {
      try {
        setCargandoPacientes(true);
        const res = await axios.get("/api/pacientes", {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });

        setPacientes(res.data.map(p => ({
          value: p.n_expediente,
          label: `${p.n_expediente} - ${p.nombre} ${p.primer_apellido} ${p.segundo_apellido}`.trim(),
        })));
      } catch (e) {
        console.error("Error cargando pacientes", e);
      } finally {
        setCargandoPacientes(false);
      }
    };

    cargarPacientes();
  }, []);


  useEffect(() => {
    if (!cita) return;
    setProfesionalSeleccionado(cita.profesional || profesional);

    const fechaInicio =
      cita.fechaInicio instanceof Date
        ? cita.fechaInicio
        : new Date(cita.fechaInicio);

    setFecha(fechaInicio.toISOString().slice(0, 10));
    setHora(fechaInicio.toTimeString().slice(0, 5));

    if (cita.duracionMin) {
      setDuracion(cita.duracionMin);
    }

    if (cita.paciente) {
      setPaciente({
        value: cita.nExpediente,
        label: `${cita.nExpediente} - ${cita.paciente}`
      });
    }

    if (cita.tratamiento) {
      setTratamiento({
        label: cita.tratamiento,
        value: cita.tratamiento
      });
    }
  }, [cita]);

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>{cita?.id ? "Editar cita" : "Nueva cita"}</h3>
        <div className="modal-header-row">
          <label>Clínica</label>
          <label>Profesional</label>
          <select
            value={profesionalSeleccionado}
            onChange={e => setProfesionalSeleccionado(e.target.value)}
          >
            <option value="">Seleccionar profesional</option>
            <option value="MARIA">MARIA</option>
            <option value="LUCIA">LUCIA</option>
            <option value="BARBARA">BARBARA</option>
            <option value="ALESSIO">ALESSIO</option>
            <option value="AINHOA">AINHOA</option>
            <option value="PAULA">PAULA</option>
          </select>
        </div>
        <label>Paciente</label>
        <div className="fila-paciente">
          {cargandoPacientes ? (
            <div className="spinner"></div>
          ) : (
            <Select
              classNamePrefix="react-select"
              options={pacientes}
              value={paciente}
              onChange={setPaciente}
            />
          )}
          <button onClick={() => setMostrarModalPaciente(true)}>
            + Nuevo
          </button>
        </div>

        <label>Tratamiento</label>
        <Select
          options={TRATAMIENTOS}
          value={tratamiento}
          onChange={setTratamiento}
        />

        <label>Fecha</label>
        <input type="date" value={fecha} onChange={e => setFecha(e.target.value)} />

        <div className="fila-hora-duracion">
          <div className="campo-inline">
            <label>Hora</label>
            <input
              type="time"
              value={hora}
              onChange={e => setHora(e.target.value)}
            />
          </div>
          <div className="campo-inline campo-duracion">
            <label>Duración (min)</label>
            <input
              type="number"
              value={duracion}
              onChange={e => setDuracion(Number(e.target.value))}
            />
          </div>
        </div>

        <div className="acciones-modal">
          {cita?.id && (
            <button
              className="btn-danger"
              onClick={async () => {
                if (!window.confirm("¿Eliminar esta cita?")) return;
                await eliminarCita(cita.id);
                onCitaCreada();
                onClose();
              }}
            >
              Eliminar
            </button>
          )}
          <div className="acciones-derecha">
            <button onClick={onClose}>Cancelar</button>
            <button
              className="btn-primary"
              disabled={!profesionalSeleccionado || !paciente || !tratamiento || !fecha || !hora}
              onClick={guardar}
            >
              {cita?.id ? "Guardar cambios" : "Crear cita"}
            </button>
          </div>
        </div>
      </div>
      {mostrarModalPaciente && (
        <ModalNuevoPaciente
          onClose={() => setMostrarModalPaciente(false)}
          onGuardar={(nuevoPaciente) => {
            // por ahora solo lo dejamos seleccionado en el select
            const opcion = {
              value: nuevoPaciente.n_expediente,
              label: `${nuevoPaciente.n_expediente} - ${nuevoPaciente.nombre} ${nuevoPaciente.primer_apellido} ${nuevoPaciente.segundo_apellido || ""}`.trim()
            };

            setPaciente(opcion);
            setMostrarModalPaciente(false);
          }}
        />
      )}
    </div>
  );
}
